import { ca } from '../i18n/ca';
import type { LoadProblem } from './loadProblem';

/** What was being read, as the sentence names it. */
export type Loaded = keyof typeof ca.missionUi.load.what;

/**
 * The sentence for a list that did not arrive (`loadProblem.ts`), with a way
 * to ask again: after an admin grants the permission the next request already
 * has it, so "try again" is all a refused member needs — no signing out.
 */
export function LoadProblemNote({
  problem,
  what,
  onRetry,
}: {
  problem: LoadProblem;
  what: Loaded;
  onRetry: () => void;
}) {
  const t = ca.missionUi.load;
  return (
    <p className="small warn" role="alert">
      {problem === 'forbidden'
        ? t.forbidden(t.what[what])
        : problem === 'offline'
          ? ca.connection.offlineWhat(t.what[what])
          : t.failed(t.what[what])}{' '}
      <button type="button" className="link" onClick={onRetry}>
        {t.retry}
      </button>
    </p>
  );
}
